/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 * align {string} column alignment left/center/right
 */

export default [
  {
    id: 1,
    label: '',
    field_name: 'join',
    source_field: 'streaming_host_url',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 2,
    label: '',
    field_name: 'details',
    source_field: 'webackend_id',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 3,
    label: 'Teacher',
    field_name: 'teacher_name',
    source_field: 'teacher_name',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
  },
  {
    id: 4,
    label: 'Date',
    field_name: 'scheduled_at',
    source_field: 'date',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
  },
  {
    id: 5,
    label: 'Time',
    field_name: 'time',
    source_field: 'descriptive_time',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 26,
    label: 'Teaching Language',
    field_name: 'language_code',
    source_field: 'language_code',
    showColumn: true,
    pinned: true,
  },
  {
    id: 6,
    label: 'Length',
    field_name: 'duration_minutes',
    source_field: 'duration_minutes',
    showColumn: true,
  },
  {
    id: 7,
    label: 'Day',
    field_name: 'day',
    source_field: 'day',
    showColumn: false,
  },
  {
    id: 8,
    label: 'Class Type',
    field_name: 'class_type',
    source_field: 'class_type_label',
    showColumn: true,
    alwaysVisible: true,
  },
  {
    id: 9,
    label: 'Class Status',
    field_name: 'status',
    source_field: 'status',
    showColumn: false,
    align: 'center',
  },
  {
    id: 10,
    label: 'First Name',
    field_name: 'learner_first_name',
    source_field: 'learner_first_name',
    showColumn: false,
  },
  {
    id: 11,
    label: 'Last Name',
    field_name: 'learner_last_name',
    source_field: 'learner_last_name',
    showColumn: false,
  },
  {
    id: 12,
    label: 'Learner Email',
    field_name: 'email',
    source_field: 'learner_email',
    showColumn: true,
    suppressSorting: true,
  },
  {
    id: 13,
    label: 'Organization',
    field_name: 'organization_id',
    source_field: 'organization',
    showColumn: false,
  },
  {
    id: 14,
    label: 'Level',
    field_name: 'level',
    source_field: 'level',
    showColumn: true,
  },
  {
    id: 15,
    label: 'Reservations',
    field_name: 'number_of_participants',
    source_field: 'number_of_participants',
    showColumn: true,
  },
  {
    id: 16,
    label: 'Group Attendance',
    field_name: 'group_attendance',
    source_field: 'group_attendance',
    showColumn: false,
  },
  {
    id: 17,
    label: 'Training Plan',
    field_name: 'training_plan_slug',
    source_field: 'training_plan',
    showColumn: false,
  },
  {
    id: 18,
    label: 'Topic',
    field_name: 'topic',
    source_field: 'topic',
    showColumn: true,
  },
  {
    id: 19,
    label: 'Lesson',
    field_name: 'lesson_title',
    source_field: 'lesson_title',
    showColumn: true,
  },
  {
    id: 20,
    label: 'Feedback Status',
    field_name: 'feedback_submitted',
    source_field: 'feedback_submitted',
    showColumn: false,
  },
  {
    id: 21,
    label: 'Class Rating',
    field_name: 'learner_found_class_helpful',
    source_field: 'learner_found_class_helpful',
    showColumn: false,
  },
  {
    id: 22,
    label: 'Reservation Max',
    field_name: 'max_participants',
    source_field: 'max_participants',
    showColumn: false,
  },
  {
    id: 23,
    label: 'Student Cancel Time',
    field_name: 'canceled_at',
    source_field: 'canceled_at',
    showColumn: false,
  },
  {
    id: 24,
    label: 'Class Booked Timestamp',
    field_name: 'created_at',
    source_field: 'created_at_descriptive_datetime',
    showColumn: false,
  },
  {
    id: 25,
    label: 'Class ID',
    field_name: 'webackend_id',
    source_field: 'webackend_id',
    showColumn: false,
    pinned: false,
  },
];
